export enum PestKind {
  Category = "CATEGORY",
  Indicator = "INDICATOR",
}

export interface PestGroup {
  id: string;
  companyId: string;
  name: string;
  description?: string;
  CreatedAt?: string;
  UpdatedAt?: string;
}

export interface PestGroupSnapshot {
  companyId: string;
  sourceId: string;
  name: string;
  description?: string;
  takenAt: string;
}

export interface Pest {
  id: string;
  companyId: string;
  kind: PestKind;
  group?: PestGroupSnapshot;
  name: string;
  technicalTerm?: string;
  abbreviation?: string;
  description?: string;
  synonyms: string[];
  CreatedAt?: string;
  UpdatedAt?: string;
}

export interface PestSnapshot {
  companyId: string;
  sourceId: string;
  kind: PestKind;
  group?: PestGroupSnapshot;
  name: string;
  technicalTerm?: string;
  abbreviation?: string;
  description?: string;
  synonyms: string[];
  takenAt: string;
}

export interface PutPestGroupRequest {
  companyId: string;
  group: PestGroup;
}

export interface ShowPestGroupRequest {
  id: string;
}

export interface DeletePestGroupRequest {
  id: string;
}

export interface PestGroupListRequest {
  company?: {
    active: boolean;
    values: string[];
  };
  limit?: number;
  offset?: number;
}

export interface PestGroupListResponse {
  items: PestGroup[];
}

export interface PutPestRequest {
  companyId: string;
  pest: Pest;
}

export interface ShowPestRequest {
  id: string;
}

export interface DeletePestRequest {
  id: string;
}

export interface PestListRequest {
  company?: {
    active: boolean;
    values: string[];
  };
  kind?: PestKind;
  noGroup?: boolean;
  q?: string;
  limit?: number;
  offset?: number;
}

export interface PestListResponse {
  items: Pest[];
}
